import * as React from "react";
const SvgBonusCards = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	id: "Rating-Star-Add--Streamline-Streamline-3.0",
	...props
}, /* @__PURE__ */ React.createElement("desc", null, "\n		Rating Star Add Streamline Icon: https://streamlinehq.com\n	"), /* @__PURE__ */ React.createElement("defs", null), /* @__PURE__ */ React.createElement("title", null, "rating-star-add"), /* @__PURE__ */ React.createElement("path", {
	d: "M11.25 17.25a6 6 0 1 0 12 0 6 6 0 1 0 -12 0",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	d: "m17.25 14.25 0 6",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	d: "m14.25 17.25 6 0",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	d: "m22.732 10.112 0.278 -0.275a0.805 0.805 0 0 0 -0.5 -1.374l-6.44 -0.638L12.729 1.2a0.819 0.819 0 0 0 -1.458 0L7.925 7.825l-6.44 0.638a0.805 0.805 0 0 0 -0.5 1.374l5.3 5.253 -1.956 7.138a0.813 0.813 0 0 0 1.151 0.935l3.737 -1.851",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}));
export { SvgBonusCards as ReactComponent };
